import { useEffect, useState } from 'react';
import WebApp from '@twa-dev/sdk';

export interface TelegramUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  language_code?: string;
  is_premium?: boolean;
  photo_url?: string;
}

export function useTelegramWebApp() {
  const [isReady, setIsReady] = useState(false);
  const [user, setUser] = useState<TelegramUser | null>(null);

  useEffect(() => {
    // Инициализация WebApp
    WebApp.ready();
    setIsReady(true);

    // Настройка темы
    WebApp.expand();
    WebApp.disableClosingConfirmation();

    // Получение данных пользователя
    if (WebApp.initDataUnsafe?.user) {
      setUser(WebApp.initDataUnsafe.user as TelegramUser);
    }

    // Настройка цветов под тему Telegram
    if (WebApp.themeParams) {
      document.documentElement.style.setProperty(
        '--tg-theme-bg-color',
        WebApp.themeParams.bg_color || '#ffffff'
      );
      document.documentElement.style.setProperty(
        '--tg-theme-text-color',
        WebApp.themeParams.text_color || '#000000'
      );
      document.documentElement.style.setProperty(
        '--tg-theme-button-color',
        WebApp.themeParams.button_color || '#0098EA'
      );
      document.documentElement.style.setProperty(
        '--tg-theme-button-text-color',
        WebApp.themeParams.button_text_color || '#ffffff'
      );
    }
  }, []);

  const showAlert = (message: string) => {
    WebApp.showAlert(message);
  };

  const showConfirm = (message: string): Promise<boolean> => {
    return new Promise((resolve) => {
      WebApp.showConfirm(message, resolve);
    });
  };

  const openLink = (url: string, options?: { try_instant_view: boolean }) => {
    WebApp.openLink(url, options);
  };

  const openTelegramLink = (url: string) => {
    WebApp.openTelegramLink(url);
  };

  const close = () => {
    WebApp.close();
  };

  const setMainButton = (text: string, onClick: () => void) => {
    WebApp.MainButton.setText(text);
    WebApp.MainButton.onClick(onClick);
    WebApp.MainButton.show();
  };

  const hideMainButton = () => {
    WebApp.MainButton.hide();
  };

  const showMainButtonProgress = () => {
    WebApp.MainButton.showProgress();
  };

  const hideMainButtonProgress = () => {
    WebApp.MainButton.hideProgress();
  };

  const hapticFeedback = (type: 'light' | 'medium' | 'heavy' | 'success' | 'warning' | 'error') => {
    if (type === 'light' || type === 'medium' || type === 'heavy') {
      WebApp.HapticFeedback.impactOccurred(type);
    } else {
      WebApp.HapticFeedback.notificationOccurred(type as 'error' | 'success' | 'warning');
    }
  };

  return {
    WebApp,
    isReady,
    user,
    showAlert,
    showConfirm,
    openLink,
    openTelegramLink,
    close,
    setMainButton,
    hideMainButton,
    showMainButtonProgress,
    hideMainButtonProgress,
    hapticFeedback,
  };
}
